import type { ReactNode } from 'react';

import { organizationFeatureStrings } from 'constants/strings';
import { useCurrentUser } from 'hooks';
import type { EOrganizationFeature } from 'types/enum';
import { isOrganizationFeatureEnabled } from 'utils/organizationFeature';

type RequireOrganizationFeatureProps = {
  feature: EOrganizationFeature;
  children: ReactNode;
};

// 無効な機能の画面はリダイレクトせず、理由をその場に表示する。
export function RequireOrganizationFeature({
  feature,
  children,
}: RequireOrganizationFeatureProps) {
  const { data: user, isLoading } = useCurrentUser();

  if (isLoading) {
    return null;
  }

  if (!isOrganizationFeatureEnabled(user, feature)) {
    return (
      <p className="p-6 text-sm text-muted">
        {organizationFeatureStrings.unavailable.replace(
          '$feature',
          organizationFeatureStrings.labels[feature],
        )}
      </p>
    );
  }

  return <>{children}</>;
}
